
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inventory/racine",
      function () {
        return require("private-next-pages/en/inventory/racine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inventory/racine"])
      });
    }
  